module.exports = __webpack_public_path__ + "img/success.cd5b1dbc.png";